import React, { useState, useEffect, useRef } from 'react';
import Table from 'react-bootstrap/Table';
import * as api from '../elements/api/api';
import * as bm from '../elements/api/BookmarkManagement'
import * as cf from '../elements/api/CoreFunctions'
import { Notyf } from 'notyf';


function Clips(props) {
  const JOB_EXPIRATION_DURATION = 86400;

  const notyf = new Notyf(
    {
      dismissible: true
    }
  );
  function formatTime(timestamp) {
    let date = new Date(timestamp * 1000);
    let formatedDate =
      date.getDate() + "." +
      (date.getMonth() + 1) + "." +
      date.getFullYear() + " - " +
      date.getHours() + ":" +
      date.getMinutes() + ":" +
      date.getSeconds()
      ;
    return formatedDate;

  }




  const removeChild = (id) => {
    let newRows = props.rows.filter(row => row.id !== id);
    props.setRows(newRows);
  }

  const addClipToPlaylist = (item) => {
    cf.addClipToPlaylist(props.playlistElements,props.setPlaylistElements,item)
  }

  const addBookmark = (mediaElement) => {
    cf.addBookmark(mediaElement.url, mediaElement.title);
  }

    const renewClipExpiration = (i) => {
      api.renewClipExpiration(props.rows[i].id, () => {
        let rows = [...props.rows];
        rows[i].ts_last_action = Math.floor(Date.now() / 1000);
        console.log(rows[i].ts_last_action);
        props.setRows(rows);
        notyf.success({
          message: 'Clip expiration date was renewed successfully', duration: 5000, position: {
            x: 'right', // 'left', 'center' oder 'right'
            y: 'top'    // 'top' oder 'bottom'
          }
        });
      })
    }

    const removeClip = (id) => {
      let confirmed = window.confirm("Do you realy want remove this job?");
      if (confirmed) {
        api.removeJob(id, () => {
          removeChild(id);
          notyf.success({
            message: 'Clip removed successfully', duration: 5000, position: {
              x: 'right', // 'left', 'center' oder 'right'
              y: 'top'    // 'top' oder 'bottom'
            }
          });
        });
      }
    };


    return (
      <div>
        <h4>Clips</h4>
        {/* 
      <div className='m-2 row'>
        <div class='col-2'>TestTestTestTestTestTestTest</div>
        <div class='col col-xs-2'>TeTestTestTestTestTestTestst</div>
        <div class='col col-xs-2'>TeTestTestTestTestTestTestTestst</div>
        <div class='col col-xs-2'>TesTestTestTestTestTestt</div>
        <div class='col col-xs-2'>TeTestTestTestTestTestTestst</div>
      </div> */}

        <Table striped hover>
          <thead>
            <tr>
              <th class="tableClipsResponsive">Start</th>
              <th class="tableClipsResponsive">Type</th>
              <th>Title</th>
              <th>Current Status</th>
              {/* Tools */}
              <th></th>
            </tr>
          </thead>
          <tbody>
            {
              props.rows.map(
                (row, i) => {
                  const current_ts = Math.floor(Date.now() / 1000);
                  const is_job_expired = current_ts - row.ts_last_action > JOB_EXPIRATION_DURATION;
                  return (
                    <tr className={is_job_expired ? 'border-job-expired' : ''} key={i}>
                      <td class="tableClipsResponsive">{formatTime(row.ts_start)}</td>
                      <td class="tableClipsResponsive">{row.type}</td>
                      <td><a target='_blank' href={row.url}>{row.title}</a></td>
                      <td>{api.getStatus(row.status)}</td>
                      <td>
                        <div className='tools'>
                          {/* Play */}
                          {
                            row.status !== api.PENDING &&
                            <a href="javascript:;" onClick={() => props.playMedia(row)}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z" /></svg></a>
                          }
                          {/* Add to Playlist */}
                          {
                            row.status !== api.PENDING &&
                            <a onClick={() => addClipToPlaylist(row)} href="javascript:;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" /></svg></a>
                          }
                          {/* Download */}
                          {
                            row.status === api.FINISHED &&
                            <a href={row.download_url}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" /></svg></a>
                          }
                          {/* Renew expiraion date of clip */}
                          {
                            row.status === api.FINISHED & is_job_expired ?
                              <a href="javascript:;" onClick={() => renewClipExpiration(i)}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M500.7 138.7L512 149.4L512 96C512 78.3 526.3 64 544 64C561.7 64 576 78.3 576 96L576 224C576 241.7 561.7 256 544 256L416 256C398.3 256 384 241.7 384 224C384 206.3 398.3 192 416 192L463.9 192L456.3 184.8C456.1 184.6 455.9 184.4 455.7 184.2C380.7 109.2 259.2 109.2 184.2 184.2C109.2 259.2 109.2 380.7 184.2 455.7C259.2 530.7 380.7 530.7 455.7 455.7C463.9 447.5 471.2 438.8 477.6 429.6C487.7 415.1 507.7 411.6 522.2 421.7C536.7 431.8 540.2 451.8 530.1 466.3C521.6 478.5 511.9 490.1 501 501C401 601 238.9 601 139 501C39.1 401 39 239 139 139C238.9 39.1 400.7 39 500.7 138.7z" /></svg></a>
                              :
                              ''
                          }
                          {/* Add clip as bookmark */}
                          {
                            row.status >= api.IN_QUEUE ?
                              <a href="javascript:;" onClick={() => { addBookmark(row) }}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M192 64C156.7 64 128 92.7 128 128L128 544C128 555.5 134.2 566.2 144.2 571.8C154.2 577.4 166.5 577.3 176.4 571.4L320 485.3L463.5 571.4C473.4 577.3 485.7 577.5 495.7 571.8C505.7 566.1 512 555.5 512 544L512 128C512 92.7 483.3 64 448 64L192 64z" /></svg></a>
                              :
                              ''
                          }
                          {/* Remove */}
                          {
                            (row.status !== api.IN_PROGRESS && row.status !== api.PENDING) &&
                            <a href="javascript:;" onClick={() => removeClip(row.id)}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z" /></svg></a>
                          }
                        </div>
                      </td>
                    </tr>
                  );
                }
              )
            }
          </tbody>
        </Table>
      </div>
    );
  }

  export default Clips;